// extracted by mini-css-extract-plugin
export default {"ScreenXXSMax":"(max-width: 543px)","Bluecheese":"#615CFF","list":"G80f338","item":"G839231"};